import React, { Component } from 'react';
import { Form, Modal, Input } from 'antd';
import styles from './index.less';

const { Item } = Form;

@Form.create()
class EditModal extends Component {

  constructor(props) {
    super(props);

    this.state = {
      name: props.data.name || '',
      // name: '',
    };
  }

  handleOk = () => {
    const { onOk, form, data } = this.props;
    const { id } = data;
    const { validateFields } = form;
    validateFields((err, { name=''}) => {
      if(!err && onOk) {
        onOk({id, name});
      }
    })

  }

  render() {
    const { name } = this.state;
    const { title, form, visible, onCancel, data } = this.props;
    const { getFieldDecorator, getFieldValue } = form;
    // const { name } = data;
    const value = getFieldValue('name') || name || '';
    return (
      <Modal
        title={title}
        centered
        visible={visible}
        onOk={this.handleOk}
        onCancel={onCancel}
        okButtonProps={{
          disabled: !value.trim().length || value.trim().length > 30,
        }}
        wrapClassName={styles.editModal}
      >
        <Form labelCol={{ span: 5 }} wrapperCol={{ span: 18 }}>
          <Item label="名称">
            {getFieldDecorator('name', {
              initialValue: name,
              rules: [
                { required: true, message: '请输入名称' },
                { max: 30, message: '模版名称不能超过30个汉字' },
              ],
              onChange: e => this.setState({ name: e.target.value }),
            })(<Input placeholder="请输入" suffix={`${name.length || 0}/30`} />)}
          </Item>
        </Form>
      </Modal>
    );
  }
}

export default EditModal;